//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue';
import { FocusTrap } from 'focus-trap-vue';
import clickOutside from '@/shared/directives/click-outside';

Vue.component('FocusTrap', FocusTrap);

export default Vue.extend({
  name: 'MoreInfoButton',
  props: {
    title: { type: String, default: '' },
    description: { type: String, default: '' },
    cardClass: { type: String, default: '' },
  },
  data() {
    const mobileQuery = process.client && window.matchMedia('(max-width: 768px)');
    const tabletQuery = process.client && window.matchMedia('(min-width: 768px) and (max-width: 1200px)');
    return {
      isOpen: false,
      mobileQuery,
      tabletQuery,
      isMobile: mobileQuery.matches,
      isTablet: tabletQuery.matches,
      mobileStyles: {
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      },
    };
  },
  directives: {
    clickOutside,
  },
  mounted() {
    this.mobileQuery.addListener(() => {
      this.isMobile = this.mobileQuery.matches;
    });

    this.tabletQuery.addListener(() => {
      this.isTablet = this.tabletQuery.matches;
    });
  },
  methods: {
    open() {
      this.isOpen = true;
      this.$emit('cardOpen');
    },
    close() {
      this.isOpen = false;
    },
  },
  computed: {
    getElementName() {
      return `${this.$options.name}_${this.title}`;
    },
    getMoreInfoLabel() {
      return `more info about ${this.title}`;
    },
  },
});
